import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthenticationMethod } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IFetchAuthenticationMethodsForUserOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
  sessionKey?: string;
}

export const createRequest = (userId: number, opts: IFetchAuthenticationMethodsForUserOpts): Request => {
  const { apiUrl, apikey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(`user/${userId}/methods`).build().toString();

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };
  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }
  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function fetchAuthenticationMethodsForUser(
  userId: number,
  opts: IFetchAuthenticationMethodsForUserOpts,
): Promise<JsonQuery<IResultstash<IAuthenticationMethod[]>>> {
  return await fetchJsonQuery<IResultstash<IAuthenticationMethod[]>>(createRequest(userId, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}
export default fetchAuthenticationMethodsForUser;
